import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AdMarkerPoints } from "./AdMarkerPoints/index.js";
import { toPercentage } from "../../../../lib/videoUtils.js";
/* empty css           */
const Slider = ({
  ariaLabel = "",
  className = "",
  max,
  min,
  onChange,
  step = 0,
  testId = "",
  value,
  isVolumeSlider = false
}) => {
  return /* @__PURE__ */jsxs("div", { className: classNames("omega_scrubberContainer", className), children: [
    /* @__PURE__ */jsx(
      "input",
      {
        "aria-label": ariaLabel,
        className: classNames("omega_slider", className),
        max,
        min,
        onChange,
        step,
        style: (
        /** @type {React.CSSProperties} */
        { "--sliderPosition": `${toPercentage(value, min, max)}%` }),

        "data-testid": testId,
        type: "range",
        value,
        list: "tickmarks"
      }
    ),
    !isVolumeSlider && /* @__PURE__ */jsx(AdMarkerPoints, { min, max })]
  });
};
export {
  Slider,
  Slider as default };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/Slider/index.js.map